import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import HighlightedText from '../components/ui/HighlightedText';
import GitHubCalendar from 'react-github-calendar';
import headshot from '../assets/img/headshot.JPG';
import Moon from '../components/Moon';

export default function Home() {
  const { colors, isDark } = useTheme();
  const [audioPlaying, setAudioPlaying] = useState(false);

  const playPronunciation = () => {
    // Placeholder for audio file - replace '/pronunciation.mp3' with your audio file
    const audio = new Audio('/pronunciation.mp3');
    setAudioPlaying(true);
    audio.play().catch(() => {
      // Fallback if audio file doesn't exist yet
      console.log('Audio file not found - add your pronunciation file to public/pronunciation.mp3');
    });
    audio.onended = () => setAudioPlaying(false);
  };

  return (
    <>
    {/* Kept outside the space-y container so toggling it doesn't shift the content */}
    {isDark && <Moon />}
    <div className="space-y-4 py-8">
      {/* Header Section */}
      <section className="flex items-center space-x-6 pb-8">
        <div className="w-20 h-20 flex-shrink-0">
          <img 
            src={headshot} 
            alt="John Kim" 
            className="w-full h-full object-cover rounded-lg grayscale"
          />
        </div>
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <h1 className="text-4xl font-medium font-sans" style={{ color: colors.text }}>
              dongwhi kim
            </h1>
            <span 
              className="text-3xl cursor-help relative group"
              style={{ color: colors.textMuted }}
              title="east star"
            >
              김동휘
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap text-sm"
                   style={{ backgroundColor: colors.textMuted, color: colors.bg }}>
                east star
              </div>
            </span>
            <button 
              onClick={playPronunciation}
              className={`transition-colors duration-200 ${audioPlaying ? '' : ''}`}
              style={{ color: audioPlaying ? colors.text : colors.textMuted }}
              onMouseEnter={(e) => e.target.style.color = colors.text}
              onMouseLeave={(e) => e.target.style.color = audioPlaying ? colors.text : colors.textMuted}
              title="Play pronunciation"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89 .86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
              </svg>
            </button>
          </div>
          
          {/* External Links */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-4 text-base font-space">
            {[
              { name: 'git', url: 'https://github.com/johnkimdw' },
              { name: 'cv', url: '/cv.pdf' },
              { name: 'x', url: 'https://twitter.com/johnkimdw' },
              { name: '@', url: 'mailto:dkim37@nd.edu' },
              { name: 'scholar', url: 'https://scholar.google.com/citations?user=-dDEr-sAAAAJ&hl=en' }
            ].map((link, index, array) => (
              <React.Fragment key={link.name}>
                <a
                  href={link.url}
                  target={link.url.startsWith('mailto:') ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                  className="transition-all duration-200 hover:underline"
                  style={{ color: colors.link }}
                  onMouseEnter={(e) => e.target.style.color = colors.linkHover}
                  onMouseLeave={(e) => e.target.style.color = colors.link}
                >
                  {link.name}
                </a>
                {index < array.length - 1 && (
                  <span className="text-sm" style={{ color: colors.textMuted }}>✦</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="text-left">
        <div className="space-y-6">
          <p className="text-base leading-relaxed font-sans" style={{ color: colors.textMuted }}>
            i go by{' '}
            <HighlightedText><strong>john</strong></HighlightedText>
            , a first-year phd student at northwestern advised by <HighlightedText href="https://limanling.github.io/">manling li</HighlightedText>, and supported by the <a href="https://www.nsf.gov/funding/opportunities/grfp-nsf-graduate-research-fellowship-program" className="hover:underline" style={{ color: colors.text }} onMouseEnter={(e) => e.target.style.color = colors.text} onMouseLeave={(e) => e.target.style.color = colors.text}>nsf grfp</a>. 
            i studied cs & applied math in my undergrad at notre dame, where I worked on trustworthy AI with {' '}
            <a href="https://www.nunomoniz.co/" className="hover:underline" style={{ color: colors.text }} onMouseEnter={(e) => e.target.style.color = colors.text} onMouseLeave={(e) => e.target.style.color = colors.text}>nuno moniz</a>
            {' '}and{' '}
            <a href="http://www.meng-jiang.com/" className="hover:underline" style={{ color: colors.text }} onMouseEnter={(e) => e.target.style.color = colors.text} onMouseLeave={(e) => e.target.style.color = colors.text}>meng jiang</a>.

            <br></br>
            <br></br>

            currently, i'm exploring <strong style={{ color: colors.link }}>world models</strong>.
            
          </p>
{/*   
          <p className="text-base leading-relaxed font-sans" style={{ color: colors.textMuted }}>
            previously, i was an ai/ml sde intern at <strong>AWS</strong> SageMaker Unified Studio where i built, deployed, and scaled AI agents. i worked end-to-end, including infrastructure (IaC), to agentic workflows with memory/hitl, and MCP/A2A integrations.
          </p> */}



          {/* <br></br> */}

        {/* <p className="text-base leading-relaxed font-sans" style={{ color: colors.textMuted }}>
            In my free time, I like cooking and dancing. Feel free to reach out to discuss 
            anything related to tech, food, and shows!
          </p> */}
        </div>
      </section>

      {/* Research Section */}
      <section>
        <h2 className="text-xl font-medium mb-4 mt-10 font-sans flex items-baseline gap-3" style={{ color: colors.text }}>
          publications
          <span className="text-xs font-normal font-sans" style={{ color: colors.textMuted }}>(*=equal contribution)</span>
        </h2>
        <div className="space-y-6">
          <div className="space-y-1">
            <a 
              href="https://arxiv.org/pdf/2601.06757" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-base leading-relaxed transition-colors duration-200 hover:underline font-sans"
              style={{ color: colors.link }}
              onMouseEnter={(e) => e.target.style.color = colors.linkHover}
              onMouseLeave={(e) => e.target.style.color = colors.link}
            >
              MTMCS-Bench: Evaluating Contextual Safety of Multimodal Large Language Models in Multi-Turn Dialogues
            </a>
            <p className="text-sm font-sans" style={{ color: colors.textMuted }}>
              ACL Findings, 2026

            </p>

            <p className="text-sm font-sans" style={{ color: colors.textMuted }}>
              Zheyuan Liu*, <strong>Dongwhi Kim*</strong>, Yixin Wan, Xiangchi Yuan, Zhaoxuan Tan, Fengran Mo, Meng Jiang 
            </p>
          </div>
          <div className="space-y-1">
            <a 
              href="https://arxiv.org/pdf/2512.11661" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-base leading-relaxed transition-colors duration-200 hover:underline font-sans"
              style={{ color: colors.link }}
              onMouseEnter={(e) => e.target.style.color = colors.linkHover}
              onMouseLeave={(e) => e.target.style.color = colors.link}
            >
              From Verification Burden to Trusted Collaboration: Design Goals for LLM-Assisted Literature Reviews
            </a>
            <p className="text-sm font-sans" style={{ color: colors.textMuted }}>
              AAAI Workshop on AI for Scientific Research, 2026

            </p>

            <p className="text-sm font-sans" style={{ color: colors.textMuted }}>
              Brenda Nogueira, Werner Geyer, Andrew Anderson, Toby Jia-Jun Li, <strong>Dongwhi Kim</strong>, Nuno Moniz, Nitesh V Chawla
            </p>
          </div>
          <div className="space-y-1">
            <a 
              href="https://link.springer.com/chapter/10.1007/978-3-031-91398-3_33" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-base leading-relaxed transition-colors duration-200 hover:underline font-sans"
              style={{ color: colors.link }}
              onMouseEnter={(e) => e.target.style.color = colors.linkHover}
              onMouseLeave={(e) => e.target.style.color = colors.link}
            >
              Relevance Aware Algorithmic Recourse
            </a>
            <p className="text-sm font-sans" style={{ color: colors.textMuted }}>
              IDA, 2025

            </p>

            <p className="text-sm font-sans" style={{ color: colors.textMuted }}>
              <strong>Dongwhi Kim</strong>, Nuno Moniz.
            </p>
          </div>
        </div>
      </section>

      {/* GitHub Contributions Section */}
      <section>
        <h2 className="text-xl font-medium mb-4 mt-10 font-sans" style={{ color: colors.text }}>
          github activity
        </h2>
        <div className="w-full">
          <GitHubCalendar 
            username="johnkimdw"
            blockRadius={20}
            theme={isDark ? {
              level0: '#0f172a',
              level1: '#1e3a8a',
              level2: '#3b82f6',
              level3: '#60a5fa',
              level4: '#93c5fd',
            } : {
              level0: '#f1f5f9',
              level1: '#dbeafe',
              level2: '#93c5fd',
              level3: '#3b82f6',
              level4: '#1e40af',
            }}
            style={{
              color: colors.textMuted
            }}
          />
        </div>
      </section>


    </div>
    </>
  );
}
